// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3Ickt","list":"BalanceDue_list__2m1jq","listRow":"BalanceDue_listRow___ggRH","total":"BalanceDue_total__1tL6o"};